import productAPI from '@/api/products'
import productVariantAPI from '@/api/products/variants'
// import { HttpFunctions } from '@/api/http-functions'

export const getProductByStaticUrlAPI = ({ commit, state }, staticUrl) => {
  return new Promise((resolve) => {
    productAPI.getProductByStaticUrl(staticUrl, result => {
      commit('setProductDetail', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const getProductVariantAPI = ({ commit, state }, param) => {
  return new Promise((resolve) => {
    productVariantAPI.getProductVariant(param, result => {
      commit('setProductVariant', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const setKeywordSearch = ({ commit, state }, keyword) => {
  return new Promise((resolve) => {
    commit('setKeywordSearch', keyword)
    resolve(keyword)
  })
}

export const setSearchStatus = ({ commit, state }, status) => {
  return new Promise((resolve) => {
    commit('setSearchStatus', status)
    resolve(status)
  })
}

export const searchProducts = ({ commit, state }, keyword) => {
  return new Promise((resolve) => {
    productAPI.searchProducts(state.search, result => {
      commit('setResultSearch', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const setMoreSearch = ({ commit, state }) => {
  commit('setMoreSearch')
}

export const searchMoreProducts = ({ commit, state }) => {
  return new Promise((resolve) => {
    productAPI.searchProducts(state.search, result => {
      commit('setResultSearchMore', result.data.data)
      resolve(result.data.data)
    })
  })
}

export const setSearchOldScroll = ({ commit }, scroll) => {
  commit('setSearchOldScroll', scroll)
}

export const setProductLists = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    productAPI.getProductsByCategoryId(param, results => {
      if (results.data.status === 'success') {
        if (param.loadMore === true) {
          commit('setProductsListLoadmore', results.data.data)
        } else {
          commit('setProductsList', results.data.data)
        }

        resolve(results.data.data.products)
      } else {
        reject(new Error('Error'))
      }
    })
  })
}

export const setSelectedQuantity = ({ commit }, quantity) => {
  commit('setSelectedQuantity', quantity)
}



// WEBPACK FOOTER //
// ./src/store/modules/products/actions.js